import createBrowserHistory from 'history/lib/createBrowserHistory';
import createHashHistory from 'history/lib/createHashHistory';
import ApiClient from './helpers/ApiClient';


const environment = {
	development: {
		isProduction: false
	},
	production: {
		isProduction: true
	}
}[process.env.NODE_ENV || 'development'];

const config = {
	web: {
		realtimeengine: 'etolex',
		assets: '/',
		api: '/',
		createHistory: createBrowserHistory,
		getApiClient: new ApiClient('/api'),
	},
};

export default Object.assign(config[__MOBILE__ ? 'mobile' : 'web'], environment);


// WEBPACK FOOTER //
// ./src/config.js